export enum CC_OPERATIONS {
  'CLAIM' = 'CLAIM',
  'UNDO_CLAIM' = 'UNDO_CLAIM',
  'MARK_AS_DUPE' = 'MARK_AS_DUPE',
  'UNDO_MARK_AS_DUPE' = 'UNDO_MARK_AS_DUPE',
  'CHANGE_STARRING' = 'STAR',
}

export interface CCRowSetting {
  placeId: string; // unique identifier taken from cc-location - cc location might not have an 'id'
  ongoingCcOperation: CC_OPERATIONS;
  selected: boolean // whether row is selected
  hovered: boolean // whether row is hovered
}